import baseService from '../shared/baseService';

const editorialCategoryService = () => baseService('editorial-categories');

export default {
    editorialCategoryService
};

